import axios from 'axios'
import {API_ENDPOINTS} from '../../../constants/apiConstants'

// upload image to s3 using s3-prefix
export const uploadImageToS3 = async (file: File): Promise<string> => {
  try {
    // Step 1: Get presigned URL from backend
    const qs = `filename=${encodeURIComponent(file.name)}&contentType=${encodeURIComponent(
      file.type
    )}`
    const res = await axios.post(API_ENDPOINTS.UPLOAD_IMAGE_TO_S3(qs))

    const {uploadUrl, fileUrl} = res.data.data

    // Step 2: Upload the file to S3 using the presigned URL
    const uploadRes = await fetch(uploadUrl, {
      method: 'PUT',
      headers: {'Content-Type': file.type},
      // headers: {
      //   'Content-Type': file.type,
      //   'x-amz-acl': 'public-read', // MUST match signed header
      // },
      body: file,
    })

    if (!uploadRes.ok) throw new Error('S3 upload failed')

    // Step 3: Return the file URL
    return fileUrl.split('/public/')[1]
  } catch (err) {
    console.error('Upload error:', err)
    throw err
  }
}

// get full image url
export function getFullImageUrl(imageUrl: string) {
  if (!imageUrl) return ''

  const baseUrl =
    process.env.REACT_APP_ENV === 'production'
      ? 'https://rpm-bucket-prod.s3.us-west-2.amazonaws.com/public'
      : 'https://rpm-bucket-dev.s3.us-east-2.amazonaws.com/public'

  // Avoid duplicate slashes if imageUrl starts with '/'
  return `${baseUrl.replace(/\/$/, '')}/${imageUrl.replace(/^\/+/, '')}`
}

// get pre signed url
export const fetchSignedUrl = async (imageUrl: any) => {
  if (!imageUrl) return null
  try {
    const res = await axios.get(API_ENDPOINTS.GET_PRE_SIGNED_URL(encodeURIComponent(imageUrl)))
    return res?.data?.data?.url
  } catch (err) {
    console.error('Failed to fetch signed URL:', err)
    throw err
  }
} 